var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { DateDefaultsConst } from '../constants/date-time';
import { BaseOfferingDtoBuilder } from './base-offering.dto.builder';
import { OfferingType } from './offering.dto';
import * as moment from 'moment';
var CourseOfferingDtoBuilder = /** @class */ (function (_super) {
    __extends(CourseOfferingDtoBuilder, _super);
    function CourseOfferingDtoBuilder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CourseOfferingDtoBuilder.prototype.getOfferingType = function () {
        return OfferingType.COURSE;
    };
    CourseOfferingDtoBuilder.prototype.withRepeatEveryXWeeks = function (value) {
        this.offering.schedule.repeatEveryXWeeks = value;
        return this;
    };
    CourseOfferingDtoBuilder.prototype.withIsCourseFull = function (value) {
        this.offering.schedulePolicy.isCourseFull = value;
        return this;
    };
    CourseOfferingDtoBuilder.prototype.validOfferingDto = function () {
        var baseOfferingDto = _super.prototype.validOfferingDto.call(this);
        return __assign(__assign({}, baseOfferingDto), { schedule: __assign(__assign({}, baseOfferingDto.schedule), { classHours: this.validWeekHours(), repeatEveryXWeeks: 1 }) });
    };
    CourseOfferingDtoBuilder.prototype.withStaffMembers = function (staff) {
        var courseOffering = this.offering;
        var days = Object.keys(courseOffering.schedule.classHours);
        var staffCounter = 0;
        days
            .map(function (dayName) { return courseOffering.schedule.classHours[dayName]; })
            .forEach(function (day) {
            return day &&
                day.workingHours &&
                day.workingHours.forEach(function (workingHour) {
                    return (workingHour.staffId = staff[staffCounter++ % staff.length].id);
                });
        });
        return this;
    };
    CourseOfferingDtoBuilder.prototype.build = function () {
        return _super.prototype.build.call(this);
    };
    return CourseOfferingDtoBuilder;
}(BaseOfferingDtoBuilder));
export { CourseOfferingDtoBuilder };
var CourseOfferingDetailsDtoBuilder = /** @class */ (function (_super) {
    __extends(CourseOfferingDetailsDtoBuilder, _super);
    function CourseOfferingDetailsDtoBuilder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CourseOfferingDetailsDtoBuilder.prototype.withTotalNumberOfSessions = function (value) {
        this.offering.schedule.totalNumberOfSessions = value;
        return this;
    };
    CourseOfferingDetailsDtoBuilder.prototype.withStartTime = function (momentDate) {
        this.offering.schedule.startTime = momentDate
            .clone()
            .format(new DateDefaultsConst().TIME_FORMAT);
        return this;
    };
    CourseOfferingDetailsDtoBuilder.prototype.withEndDate = function (momentDate) {
        this.offering.schedule.endDate = momentDate
            .clone()
            .format(new DateDefaultsConst().DATE_FORMAT);
        return this;
    };
    CourseOfferingDetailsDtoBuilder.prototype.validOfferingDto = function () {
        var courseOfferingDto = _super.prototype.validOfferingDto.call(this);
        var schedule = __assign(__assign({}, courseOfferingDto.schedule), { totalNumberOfSessions: 12, startTime: moment().format(new DateDefaultsConst().TIME_FORMAT) });
        return __assign(__assign({}, courseOfferingDto), { schedule: schedule });
    };
    CourseOfferingDetailsDtoBuilder.prototype.withSessions = function (sessions, exceptionSessions) {
        this.offering.schedule.sessions = sessions;
        this.offering.schedule.exceptionSessions = exceptionSessions;
        return this;
    };
    CourseOfferingDetailsDtoBuilder.prototype.build = function () {
        return _super.prototype.build.call(this);
    };
    return CourseOfferingDetailsDtoBuilder;
}(CourseOfferingDtoBuilder));
export { CourseOfferingDetailsDtoBuilder };
//# sourceMappingURL=course-offering.dto.builder.js.map